import React from 'react';
import styled from 'styled-components';
import Container from '../components/ui/Container';
import pancakeBotImage from '../assets/pancake-bot.png';

const HeroSection = styled.section`
  position: relative;
  padding: 10rem 0 8rem;
  text-align: left;
  margin-top: -150px; /* Pull up to overlap with header */
  padding-top: calc(10rem + 80px); /* Add back the header height to padding */
  
  &::before {
    content: '';
    position: absolute;
    top: -80px; /* Match the negative margin-top to ensure full coverage */
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      109deg, 
      rgba(255, 255, 255, 0.2) 4.13%, 
      rgba(100, 100, 100, 0.5) 80%
    );
    z-index: 0;
    pointer-events: none;
  }
  
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 15px;
  width: 100%; /* Explicitly set width to 100% */
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0) 20%,
      rgba(255, 255, 255, 0.8) 80%
    );
    z-index: 1;
    pointer-events: none;
  }
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  padding-top: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const PancakeBot = styled.div`
  position: relative;
  flex-shrink: 0;
  margin-left: 30px;
  transform: translateY(-20px); /* Move slightly up for better vertical alignment */
  
  img {
    max-width: 100%;
    height: auto;
    max-height: 500px;
    object-fit: contain;
    filter: drop-shadow(0 10px 25px rgba(0, 0, 0, 0.15)); /* Add subtle shadow */
    
    @media (max-width: 1200px) {
      max-height: 400px;
    }
    
    @media (max-width: 768px) {
      max-height: 300px;
      margin-top: 40px;
    }
    
    @media (max-width: 480px) {
      display: none;
    }
  }
`;

const TitleWrapper = styled.div`
  position: relative;
  display: inline-block;
  margin-left: 50px;
`;

const GreenRectangle = styled.div`
  position: absolute;
  width: 370px;
  height: 114px;
  background-color: #BEEA1F;
  left: -50px;
  top: 127px;
  z-index: -1;
  
  @media (max-width: 1200px) {
    width: 300px;
    height: 100px;
  top: 87px;
  }
  
  @media (max-width: 768px) {
    width: 250px;
    height: 60px;
    top: 62px
  }
  
  @media (max-width: 480px) {
    width: 200px;
    height: 50px;
    top: 45px;
  }
`;

const HeroTitle = styled.h1`
  color: #000;
  font-family: 'Poppins', sans-serif;
  font-size: 128px;
  font-style: normal;
  font-weight: 500;
  line-height: 96%;
  letter-spacing: -7.68px;
  margin-bottom: 2rem;
  padding-left: 50px;
  text-align: left;
  position: relative;
  
  @media (max-width: 1200px) {
    font-size: 96px;
    letter-spacing: -5.76px;
  }
  
  @media (max-width: 768px) {
    font-size: 64px;
    letter-spacing: -3.84px;
  }
  
  @media (max-width: 480px) {
    font-size: 48px;
    letter-spacing: -2.88px;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 1.5rem;
  font-weight: 500;
  color: #555;
  max-width: 550px;
  margin: 0 0 2rem;
  padding-left: 100px;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const Section = styled.section`
  padding: 5rem 0;
  position: relative;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #333;
`;

const SectionContent = styled.p`
  font-size: 1.2rem;
  line-height: 1.7;
  color: #555;
  max-width: 800px;
`;

// Create a semi-transparent white background for content sections
const ContentBox = styled.div`
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 8px;
  padding: 2.5rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
`;

const Home = () => {
  return (
    <>
      <HeroSection >
        <Container>
          <HeroContent>
            <div style={{ position: 'relative' }}>
              <TitleWrapper>
                <GreenRectangle />
                <HeroTitle>Engineering <br/> Bots that Delight</HeroTitle>
              </TitleWrapper>
              <HeroSubtitle>
                Creating robots with personality, precision, and purpose
              </HeroSubtitle>
            </div>
            <PancakeBot>
              <img src={pancakeBotImage} alt="Pancake Bot" />
            </PancakeBot>
          </HeroContent>
        </Container>
      </HeroSection>
      
      <Section>
        <Container>
          <ContentBox>
            <SectionTitle>Bot Fleet</SectionTitle>
            <SectionContent>
              Each Roaring Bot is built with precision engineering and personality in mind. 
              Designed and assembled in our workshop, our robots combine top end hardware 
              with advanced computing architecture to create movement that feels organic, 
              not mechanical.
            </SectionContent>
          </ContentBox>
        </Container>
      </Section>
      
      <Section>
        <Container>
          <ContentBox>
            <SectionTitle>Our Story</SectionTitle>
            <SectionContent>
              We're a team of robotics enthusiasts who believe technology should do more 
              than function—it should connect, engage, and bring joy. Our journey began 
              with a simple question: why do robots have to be cold and impersonal.
            </SectionContent>
          </ContentBox>
        </Container>
      </Section>
    </>
  );
};

export default Home;